import { Injector } from "@angular/core";
import { WorkspaceBase } from "../../../../../../components/common/workspace-base/workspace-base";
import { GridActionHandlerBase } from "../../../../../../components/common/grid-base/actions/grid-action-handler-base";
import { AppLoadingIndicatorService } from "../../../../../../services/app-loading-indicator.service";
import { take } from "rxjs";

/**
 * Publishes or unpublishes a Valuation Event
 */
export class PublishUnpublishPortfolioGridActionHandler extends GridActionHandlerBase {
  /**
   * AppLoadingIndicatorService
   */
  private appLoadingIndicator: AppLoadingIndicatorService;
  /**
   * Constructor
   * @param injector Ihe Angular injector
   * @param workspace The workspace in which the action should be performed
   * @param topic Topic (subscribeEvent topic)
   * @param action The action
   */
  constructor(injector: Injector, workspace: WorkspaceBase, topic: string, private action: 'publish' | 'unpublish' | 're-publish') {
    super(injector, workspace, topic);
    this.appLoadingIndicator = this.injector.get(AppLoadingIndicatorService);
  }

  /**
  * Handles an event
  * @param _payload The (untyped) payload. Can also be a callback function
  */
  public handle(_payload: any): void {
    switch (this.action) {
      case 'publish': {
        this.publish(false);
        break;

      } case 're-publish': {
        this.publish(true);
        break;

      }
      case 'unpublish': {
        this.publishActionExecute(false, "unpublishPortfolioConfirmDialog", "Failed to unpublish portfolio!");
        break;
      }
    }
  }

  /**
   * Publish
   * @param rePublish Re-ublish already published?
   */
  private publish(rePublish: boolean) {
    const selectedItem = this.workspace.grid.selectedItem;
    if (selectedItem) {
      this.validateConversionRates(selectedItem.Oid).then((hasConversionRates) => {
        if (hasConversionRates) {
          this.validateDataBeforePublish("publishPortfolioConfirmDialog", rePublish ? "Failed to re-publish portfolio!" : "Failed to publish portfolio!", 'publishPortfolio');
        } else {
          this.displayMissingConversionRatesDialog();
        }
      });
    }
    else {
      this.eventBus.broadcastEvent("openConfirmDialog", {
        success: () => {
          //Nothing
        }
      }, 'errorMessageChoosePortfolio');
    }
  }

  /**
   * Data validation before publish
   * @param dialogTranslation
   * @param errorMessage
   * @param publishOrRepublish
   */
  private validateDataBeforePublish(dialogTranslation, errorMessage, publishOrRepublish) {
    const selectedItem = this.workspace.grid.selectedItem;

    if (selectedItem?.ParentId) {
      //Child job
      if (!selectedItem.ValuationDate || selectedItem.ValuationStatusId === 0) {
        this.eventBus.broadcastEvent('openPublishNavigationPopup', selectedItem, publishOrRepublish);
      } else {
        this.publishActionExecute(true, dialogTranslation, errorMessage);
      }
    }
    //Normal job
    else if (!selectedItem.ValuationDate || selectedItem.ValuationStatusId === 0 || selectedItem.niy === 0 || selectedItem.nry === 0 || selectedItem.ney === 0) {
      this.eventBus.broadcastEvent('openPublishNavigationPopup', selectedItem, publishOrRepublish);
    } else {
      //Normal job
      this.publishActionExecute(true, dialogTranslation, errorMessage);
    }
  }

  /**
  * Gets the API GET endpoint for loading a single BO by it's OID
  * @param oid The BO's OID
  */
  private getPublishEndpoint(oid: number): string {
    return this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', `ValuationPortfolios/publish?oid=${oid}`);
  }
  /**
  * Gets the API GET endpoint for loading a single BO by it's OID
  * @param oid The BO's OID
  */
  private getUnpublishEndpoint(oid: number): string {
    return this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', `ValuationPortfolios/unpublish?oid=${oid}`);
  }

  /**
   * Validate the conversion rates
   * @param valuationProjectId
   * @returns
   */
  private validateConversionRates(valuationProjectId): Promise<boolean> {
    return new Promise<boolean>((resolve, _reject) => {
      //check newest state (load from API).. user could change currency on report and switch back to VP (which is not reloaded)
      const url = this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', `ValuationPortfolios?oid=${valuationProjectId}`);
      this.http.get(url).pipe(take(1)).subscribe((data: any) => {
        resolve(data.HasConversionRates);
      });
    });
  }

  /**
   * If conversion rates are missing: Inform the user
   */
  private displayMissingConversionRatesDialog(): void {
    this.eventBus.broadcastEvent("openConfirmDialog", {
      customMessage: () => { return `Please enter conversion rates for the report currencies` },
      success: () => {
        //Nothing
      }
    }, 'warrningMessageNoConversionRate');
  }

  /**
   * Eecute the publish action
   * @param publish
   * @param dialogTranslation
   * @param _errorMessage
   */
  private publishActionExecute(publish, dialogTranslation, _errorMessage) {
    const selectedItem = this.workspace.grid.selectedItem;

    if (selectedItem) {
      let url: string;
      if (publish) {
        url = this.getPublishEndpoint(selectedItem.Oid);
      }
      else {
        url = this.getUnpublishEndpoint(selectedItem.Oid);
      }

      this.eventBus.broadcastEvent("openConfirmDialog", {
        success: () => {
          this.appLoadingIndicator.show();
          this.http.post(url, {}).pipe(take(1))
            .subscribe({
              next: (gpr: any) => {
                this.appLoadingIndicator.hide();
                if (gpr.success) {
                  this.workspace.grid.selectedItem.ClientDashboardPublished = publish;
                } else {
                  //Nothing
                }
              },
              error: () => {
                this.appLoadingIndicator.hide()
              }
            });
        },
        cancel: () => {
          //do nothing: just to show Cancel button
        }
      }, dialogTranslation);
    }
    else {
      this.eventBus.broadcastEvent("openConfirmDialog", {
        success: () => {
          //Nothing
        }
      }, 'errorMessageChoosePortfolio');
    }
  }

}
